import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { AuthProvider } from './auth/AuthProvider';
import { config } from './config';
// Outfit is self-hosted (the CSP only allows 'self').
import '@fontsource/outfit/300.css';
import '@fontsource/outfit/400.css';
import '@fontsource/outfit/500.css';
import '@fontsource/outfit/600.css';
import '@fontsource/outfit/700.css';
import '@fontsource/outfit/800.css';
import './styles/tokens.css';
import './styles/app.css';

async function main() {
  const mock = config.apiMode === 'mock';
  if (mock) {
    const { startMockApi } = await import('./mocks/browser');
    await startMockApi();
  }
  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <AuthProvider config={config} mock={mock}>
        <App baseUrl={mock ? '' : config.apiUrl} mock={mock} />
      </AuthProvider>
    </StrictMode>,
  );
}

void main();
